import { Item } from '../../crud-graphql-containers/Utils/genericTypes';

export enum OrderDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export function desc(a: any, b: any, orderBy: string) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function stableSort(array: any, compareFn: (a: any, b: any) => number): Item[] {
  const stabilizedThis = array.map((el: any, index: any) => [el, index]);
  stabilizedThis.sort((a: any, b: any) => {
    const order = compareFn(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el: any) => el[0]);
}

export function getSorting(order: OrderDirection | undefined, orderBy: string) {
  return order === OrderDirection.DESC
    ? (a: any, b: any) => desc(a, b, orderBy)
    : (a: any, b: any) => -desc(a, b, orderBy);
}
